import React from 'react';
import moment from 'moment';

import FormContainer from '../../../../components/FormContainer';
import InputInfo from '../../../../components/Inputs/Info';

import { addMaskCellphone, routesStructure } from '../../../../utils';

import * as S from './styles';
import Accordion from '../../../../components/Accordion';
import CheckboxGroup from '../../../../components/Inputs/CheckboxGroup';

function ModalDataUserContent({ dataUser }) {
    const cellphone = `${dataUser.dddCelular}${dataUser.numeroCelular}`;

    const routesStructureArray = Object.values(routesStructure);

    const treatedOptions = dataUser.profile.permissoes
        .map(({ id }) => {
            const dataPermission = routesStructureArray.find((route) => route.codigo && +route.codigo === +id) || {};

            return {
                codigo: dataPermission.codigo,
                nome: dataPermission.nome,
                disabled: true,
            };
        })
        .filter(({ codigo }) => !!codigo);

    const permissions = {
        id: 'permissions',
        label: ' ',
        required: true,
        type: 'checkbox',
        value: treatedOptions.map(({ codigo }) => codigo),
        options: treatedOptions,
    };

    return (
        <S.ContainerModalBody>
            <FormContainer>
                <InputInfo field={{ label: 'Nome', value: dataUser.nomeContato, required: true }} />
                <InputInfo
                    field={{
                        label: 'Data de nascimento',
                        value:
                            dataUser.dataNascimentoContato &&
                            moment(dataUser.dataNascimentoContato).format('DD/MM/YYYY'),
                        required: true,
                    }}
                />
                <InputInfo field={{ label: 'Cargo', value: dataUser.nomeCargoContato, required: true }} />
                <InputInfo field={{ label: 'E-mail', value: dataUser.emailContato, required: true }} />
                <InputInfo
                    field={{
                        label: 'Telefone',
                        value:
                            dataUser.numeroCelular && dataUser.dddCelular
                                ? addMaskCellphone(cellphone)
                                : 'Não informado',
                        required: true,
                    }}
                />
            </FormContainer>

            <Accordion title="Contratos" hasCollapse={false}>
                <FormContainer>
                    {dataUser.contratos.map(({ codigo, nome }) => {
                        const splittedName = nome.split(' - ')[1];
                        return (
                            <InputInfo key={codigo} field={{ label: codigo, value: splittedName, required: true }} />
                        );
                    })}
                </FormContainer>
            </Accordion>

            <Accordion title="Permissões" hasCollapse={false}>
                <CheckboxGroup field={permissions} />
            </Accordion>
        </S.ContainerModalBody>
    );
}

export default ModalDataUserContent;
